"use client";
import { styled } from "@mui/material/styles";
import { Text } from "@nxt-costco-com/forge-components";
import { SpaceXs, FontLineHeightSm } from "@nxt-costco-com/forge-design-tokens";
import { CartSolid } from "@nxt-costco-com/forge-icons/icons/CartSolid";
import { ICON_SIZE_LG, ICON_SIZE_MD, ICON_SIZE_SM } from "./constants.js";
const CartIcon = styled(CartSolid)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    height: ICON_SIZE_SM,
    width: ICON_SIZE_SM
  },
  [theme.breakpoints.up("md")]: {
    height: ICON_SIZE_MD,
    width: ICON_SIZE_MD
  },
  [theme.breakpoints.up("lg")]: {
    height: ICON_SIZE_LG,
    width: ICON_SIZE_LG
  }
}));
const CartText = styled(Text)(({ theme }) => ({
  width: "fit-content",
  [theme.breakpoints.down("md")]: {
    fontSize: ".625rem",
    lineHeight: FontLineHeightSm
  },
  [theme.breakpoints.up("md")]: {
    ...theme.typography.t6
  },
  [theme.breakpoints.up("lg")]: {
    paddingLeft: SpaceXs,
    ...theme.typography.t5
  }
}));
export {
  CartIcon,
  CartText
};
